<div class="dashboard-container reporting-container">
    <app-reporting-dashboard></app-reporting-dashboard>
</div>
